module.exports = __webpack_public_path__ + "static/1199853544.0760bd8a.jpg";